import { render } from "./HubungiKami.vue?vue&type=template&id=4796c100"
import script from "./HubungiKami.vue?vue&type=script&lang=js"
export * from "./HubungiKami.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__